import { useMutation, useQuery } from 'react-query';
import { baseURL } from 'Types/APITypes';
import { QueryKeys } from 'Types';
import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { PrimTechServiceAreaLocation } from '../components/TechnicianServiceArea/types';

async function getTechServAreas(btNumber: string, stNumber?: string) {
  if (!btNumber) return null;

  const data: PrimTechServiceAreaLocation[] = await maestroApiCall({
    method: 'GET',
    endpoint: `locations/${btNumber}/primary-locations-list?filter_by_st=${
      stNumber || ''
    }`,
    baseURL,
  });
  return data;
}
export function useGetTechServAreas({
  btNumber,
  stNumber,
}: {
  btNumber: string;
  stNumber?: string;
}) {
  return useQuery<PrimTechServiceAreaLocation[] | null>(
    [QueryKeys.technicianServiceAreas, btNumber, stNumber || ''],
    () => getTechServAreas(btNumber, stNumber),
  );
}

interface SaveParams {
  btNumber: string;
  data: TechServiceAreasToSave;
}
export interface TechServiceAreasToSave {
  ship_to_list: {
    ship_to_number: string;
    secondary_st_locations: string[];
  }[];
}
async function saveTechServiceAreas({ btNumber, data }: SaveParams) {
  const apiType: MaestroAPI = {
    method: 'PUT',
    endpoint: `locations/${btNumber}/secondary-locations`,
    baseURL,
  };
  const newData: any = { ...data };

  const res = await maestroApiCall(apiType, newData);
  return res;
}
export function useSaveTechServiceAreas() {
  return useMutation(saveTechServiceAreas);
}
